<template>
  <div>
    <ImageWall
      v-show="cover"
      :url="cover"
      :isEdit="isCourseAdmin"
      @cropped="onCropped"
      waitLoading
    />
    <v-container :key="$route.fullPath" :class="cover ? '' : 'pt-16'">
      <AvatarBusiness 
        :courseDetail="courseDetail" 
        :isEdit="isCourseAdmin"
        waitLoading
      />
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import ImageWall from "@/components/ImageWall";
import AvatarBusiness from "@/components/Avatar/AvatarBusiness";
export default {
  name: "CoursesDetail",
  data() {
    return {
      cover: null,
    };
  },
  components: {
    ImageWall,
    AvatarBusiness,
  },
  created() {
    this.cover = this.imgUrl('no-img-golf.jpg')
  },
  computed: {
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail || {};
    },
    isCourseAdmin() {
      let course = this.courseDetail || {};
      let courseRole = course.courseRole || [];
      if (courseRole.length) {
        let courseAdmin =
          courseRole.findIndex((r) => r === "Course Admin") !== -1;
        if (courseAdmin) return true;
      }
      return false;
    },
  },
  watch: {
    courseDetail: {
      immediate: true,
      handler(val) {
        if (val) {
          if (val.cover) this.cover = val.cover;
        }
      },
    },
  },
  methods: {
    async onCropped(file) {
      let convert = file.replace("data:image/png;base64,", "");
      let result = await this.$store.dispatch("updateCoverCourse", convert);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.cover = file;
        this.$toast.success(this.$gettext(`Update success`));
      }
    },
  },
};
</script>
